import cc from 'classcat';
import { jsx } from 'react/jsx-runtime';
import { svgCls } from './styles/svg.js';

const HeptagonShape = ({
  fillColor = "currentColor",
  shapeRef,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  strokeColor,
  ...svgProps
}) => {
  return /*#__PURE__*/jsx("svg", {
    ...svgProps,
    className: cc([svgCls, svgProps.className]),
    ref: shapeRef,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 405.6 396.5",
    fill: fillColor,
    children: /*#__PURE__*/jsx("path", {
      d: "M293.1 396.5l112.6-141.7-40.2-176.6L202.8 0 40.2 78.6 0 254.8l112.6 141.7h180.5z"
    })
  });
};

export { HeptagonShape };
//# sourceMappingURL=HeptagonShape.js.map
